import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ControllerRoute } from '../../../shared/models/enums/controller-route.enum';
import { AppSettings } from '../../models/settings/app-settings.model';
import { AppSettingsService } from '../app-settings/app-settings.service';

export abstract class BaseDataServiceV2 {
  protected apiResourceUrl$: Observable<string>;
  protected apiResourceUrlVersions$: Observable<{ [key: number]: string }>;

  protected httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(protected appSettingsService: AppSettingsService) { }

  public appendResource(
    resource: ControllerRoute,
    options: { apiVersions: number[] } = { apiVersions: [1] }
  ): void {
    this.apiResourceUrl$ = this.appSettingsService.appSettings$.pipe(
      map((appSettings: AppSettings) => appSettings.webApi.uri + resource)
    );

    this.apiResourceUrlVersions$ = this.appSettingsService.appSettings$.pipe(
      map((appSettings: AppSettings) =>
        options.apiVersions.reduce((accumulator, currentValue) => {
          accumulator[currentValue] =
            appSettings.webApi.uriBase.replace('{v}', `${currentValue}`) +
            resource;
          return accumulator;
        }, {})
      )
    );
  }
}
